module.exports = "/packs/banner-mc-pc-27e46b0927ec1f4f089fa961964f6c95.png";